import Constants from "../../Constants";

let _currentLocale = "";
let _fallbackLanguage = "";
let _languages = [];
let _translations = {};
let _dir = "ltr";
const rtlLanguages = [
  Constants.QA.arlocaleCode,
];
export const getCurrentLocale = () => {
  return _currentLocale;
};

export const setCurrentLocale = (currentLanguage) => {
  _currentLocale = currentLanguage;
  setPageDirection(currentLanguage);
  setPageLanguage(currentLanguage);
};

export const getCurrentLanguageCode = () => {
  let REG = /^[a-z]{2}/;
  var match = _currentLocale.match(REG);
  if (!match) return "";
  return match[0];
};
export const getCurrentCountryCode = () => {
  let REG = /^[a-z]{2,}(?:-[A-Z][a-z]*)*-([A-Z]{2})$/;
  var match = _currentLocale.match(REG);
  if (!match) return "";
  return match[1];
};

function setPageDirection(language) {
  _dir = rtlLanguages.includes(language) ? "rtl" : "ltr";
  document.documentElement.dir = _dir;
}

function setPageLanguage(language) {
  document.documentElement.lang = language;
}

export const isRtl = () => {
  return _dir === "rtl";
};

export const getFallbackLanguage = () => {
  return _fallbackLanguage;
};

export const setFallbackLanguage = (fallbackLanguage) => {
  _fallbackLanguage = fallbackLanguage;
};

export const getLanguages = () => {
  return _languages;
};

export const setLanguages = (languages) => {
  _languages = languages;

  _languages.forEach((language) => {
    const loadedLanguage = require(`../Languages/${language}.json`);
    _translations[language] = loadedLanguage;
  });
};

export const getTranslations = () => {
  return _translations;
};

export const setTranslations = (translations) => {
  _translations = translations;
};

export const t = (label) => {
  return _translations[_currentLocale] && _translations[_currentLocale][label]
    ? _translations[_currentLocale][label]
    : _translations[_fallbackLanguage] &&
      _translations[_fallbackLanguage][label]
    ? _translations[_fallbackLanguage][label]
    : label;
};
